"use client"

import { trackClickToCall, trackClickToWhatsApp } from "@/lib/gtag"

type TrackableLinkProps = {
  href: string
  type: "phone" | "whatsapp"
  className?: string
  children: React.ReactNode
}

export default function TrackableLink({ href, type, className, children }: TrackableLinkProps) {
  function handleClick() {
    const phoneNumber = href.replace(/^(tel:|https:\/\/wa\.me\/)/, "")
    if (type === "phone") {
      trackClickToCall(phoneNumber)
    } else if (type === "whatsapp") {
      trackClickToWhatsApp(phoneNumber)
    }
  }

  return (
    <a
      href={href}
      onClick={handleClick}
      className={className}
      target={type === "whatsapp" ? "_blank" : undefined}
      rel={type === "whatsapp" ? "noopener noreferrer" : undefined}
    >
      {children}
    </a>
  )
}
